<div [formGroup]="form()">
    <h4>Données supplémentaires</h4>
    <div class="row mb-2">
        <div [ngClass]="rights().can('viewCurrentAlderman') ? 'col-6' : 'col-12'">
            <label class="input-label">Type(s) de décision</label>
            <p-multiSelect [appendTo]="'body'" [style]="{width: '100%'}" [options]="formOptions.decisionTypes()"
                formControlName="decisionTypes" [optionLabel]="'description'"></p-multiSelect>
        </div>
        @if(rights().can('viewCurrentAlderman')) {
        <div class="col-6">
            <label class="input-label">Echevinat(s)</label>
            <p-multiSelect [appendTo]="'body'" [style]="{width: '100%'}" formControlName="aldermens"
                [optionLabel]="'description'" [options]="formOptions.aldermanships()"></p-multiSelect>
        </div>
        }
    </div>
    <div class="col-12 mb-2">
        <label class="input-label">Classement(s)</label>
        <p-multiSelect [appendTo]="'body'" [style]="{width: '100%'}" [options]="classificationCodesOptions()"
            [loading]="fetchingClassificationCodes()" [disabled]="fetchingClassificationCodes()"
            formControlName="classifications" [optionLabel]="'label'" [virtualScroll]="true"
            [filterBy]="'label,code,description'" [virtualScrollItemSize]="'30'" [disabled]="showClassificationSelect()"
            (onChange)="onClassificationCodeChange($event)">
            <ng-template pTemplate="item" let-item>
                <span class="fw-bold">{{item.code ?? ('COMMON.UNKNOWN' | translate)}}</span>
                @if(item.description.length) {
                {{' - '}}
                }
                {{item.description ??
                ''}}
            </ng-template>
        </p-multiSelect>
    </div>
    <div class="row">
        <div class="col-6">
            <label class="input-label">Farde(s)</label>
            <p-multiSelect [appendTo]="'body'" [style]="{width: '100%'}" [disabled]="showClassificationSelect()"
                [options]="classificationFoldersOptions()" [loading]="fetchingClassificationFolders()"
                (onChange)="onClassificationFolderChange($event)" [optionLabel]="'description'" [virtualScroll]="true"
                [virtualScrollItemSize]="'30'" formControlName="folders"></p-multiSelect>
        </div>
        <div class="col-6">
            <label class="input-label">Chemise(s)</label>
            <p-multiSelect [appendTo]="'body'" [style]="{width: '100%'}"
                [disabled]="showClassificationSelect() || fetchingClassificationSheets()"
                [options]="classificationSheetsOptions()" [loading]="fetchingClassificationSheets()"
                [optionLabel]="'description'" [virtualScroll]="true" [virtualScrollItemSize]="'30'"
                formControlName="sheets"></p-multiSelect>
        </div>
    </div>
</div>